import client from '@/api/client';

// ============================================================================
// User Management API (Admin UI)
// ============================================================================

/** Full user details for management UI */
export interface UserManagement {
  id: string;
  email: string;
  name: string;
  role: string;
  department?: string;
  market?: string[];
  channel?: string[];
  app_access?: string[];
  functional_role?: string;
  is_active: boolean;
  last_login?: string;
  created_at?: string;
  updated_at?: string;
}

/** Request to create a new user */
export interface CreateUserRequest {
  email: string;
  name: string;
  role: string;
  department?: string;
  market?: string[];
  channel?: string[];
  app_access?: string[];
  functional_role?: string;
}

/** Request to update an existing user */
export interface UpdateUserRequest {
  name?: string;
  role?: string;
  department?: string;
  market?: string[];
  channel?: string[];
  app_access?: string[];
  functional_role?: string;
  is_active?: boolean;
}

/** Check if current user can manage users */
export const getCanManageUsers = async (): Promise<{ can_manage_users: boolean }> => {
  const response = await client.get<{ can_manage_users: boolean }>('/users/me/can-manage-users');
  return response.data;
};

/** Get all users for management UI */
export const getAllUsersForManagement = async (): Promise<UserManagement[]> => {
  const response = await client.get<UserManagement[]>('/users/management/all');
  return response.data;
};

/** Create a new user */
export const createUser = async (data: CreateUserRequest): Promise<UserManagement> => {
  const response = await client.post<UserManagement>('/users', data);
  return response.data;
};

/** Update an existing user */
export const updateUser = async (
  userId: string,
  data: UpdateUserRequest,
): Promise<UserManagement> => {
  const response = await client.put<UserManagement>(`/users/${userId}`, data);
  return response.data;
};
